import { BaseError } from "@core/interfaces/network/BaseError";
import axios, {
  AxiosBasicCredentials,
  AxiosRequestConfig,
  CancelToken,
  Method,
} from "axios";
import curlirize from "axios-curlirize";
import { clone, isEmpty, isNil, startsWith } from "lodash";
import nookies from "nookies";
import Qs from "qs";
import CookieManager from "../../manager/CookieManager";

export const paramsSerializer = (
  arrayFormat:
    | "indices"
    | "brackets"
    | "repeat"
    | "comma"
    | undefined = "repeat"
) => {
  return {
    paramsSerializer: (params: any) => Qs.stringify(params, { arrayFormat }),
  };
};

axios.interceptors.request.use(async function (config) {
  // const httpMetric = perf().newHttpMetric(config.url, config.method);
  // config.metadata = {httpMetric};
  // await httpMetric.start();
  return config;
});

export const ctSource = axios.CancelToken.source();

class Api {
  private _axios = axios.create({
    // ...paramsSerializer(),
    // withCredentials: false,
  });
  private baseURL: string;
  _token?: string;
  _language?: string;
  _account_id?: number;
  _ctx?: string;
  t?: any;

  constructor(baseURL: string) {
    this.baseURL = baseURL;

    this._axios.interceptors.response.use(
      (response) => {
        console.log(`check`, response.headers["content-type"]);
        return response.headers["content-type"] === "application/json"
          ? response
          : Promise.reject(response);
      },
      (error) => {
        this.handleError(error);
        return Promise.reject(error);
      }
    );

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    curlirize(this._axios, (result, error) => {
      const title = result?.command || error?.name;
      const body = result?.command || error?.message;
      console.info(result.command);
    });
  }

  /**
   * return base url for api server
   */
  async getBaseURL() {
    return this.baseURL;
  }

  /**
   * set base url for api server
   */
  setBaseURL(baseURL: string) {
    this.baseURL = baseURL;
  }

  GET = async (
    path: string,
    params?: Record<string, any>,
    header?: Record<string, string>,
    cancelToken?: CancelToken | AbortSignal,
    config?: AxiosRequestConfig
  ) => {
    return await this.request(
      "GET",
      path,
      header,
      undefined,
      params,
      null,
      cancelToken,
      config
    );
  };

  /**
   * Sends an HTTP POST request to the specified `path` with optional `data`, `header`, and `cancelToken` parameters.
   *
   * @async
   * @param {string} path - The URL path to send the request to.
   * @param {object=} data - The data to include in the request body.
   * @param {Record<string, string>=} header - The headers to include in the request.
   * @param {CancelToken=} cancelToken - A token to cancel the request.
   * @param {AxiosRequestConfig=} config - Additional configurations for the request.
   * @returns {Promise} A Promise that resolves to the response from the server.
   * @example
   *
   * const response = await POST('/api/users', { name: 'John Doe', email: 'johndoe@example.com' }, { Authorization: 'Bearer token' });
   */
  POST = async (
    path: string,
    data?: object,
    header?: Record<string, string>,
    cancelToken?: CancelToken | AbortSignal,
    config?: AxiosRequestConfig
  ) => {
    return await this.request(
      "POST",
      path,
      header,
      undefined,
      undefined,
      data,
      cancelToken,
      config
    );
  };

  paramsPOST = async (
    path: string,
    params?: Record<string, any>,
    data?: object,
    header?: Record<string, string>,
    cancelToken?: CancelToken | AbortSignal
  ) => {
    return await this.request(
      "POST",
      path,
      header,
      undefined,
      params,
      data,
      cancelToken
    );
  };

  PUT = async (
    path: string,
    data?: object,
    header?: Record<string, string>,
    cancelToken?: CancelToken | AbortSignal,
    config?: AxiosRequestConfig
  ) => {
    return await this.request(
      "PUT",
      path,
      header,
      undefined,
      undefined,
      data,
      cancelToken,
      config
    );
  };

  PATCH = async (
    path: string,
    data?: object,
    header?: Record<string, string>,
    cancelToken?: CancelToken | AbortSignal,
    config?: AxiosRequestConfig
  ) => {
    return await this.request(
      "PATCH",
      path,
      header,
      undefined,
      undefined,
      data,
      cancelToken,
      config
    );
  };

  DELETE = async (
    path: string,
    data?: object,
    cancelToken?: CancelToken | AbortSignal
  ) => {
    return await this.request(
      "DELETE",
      path,
      undefined,
      undefined,
      undefined,
      data,
      cancelToken
    );
  };

  authPOST = async (
    path: string,
    auth: AxiosBasicCredentials,
    cancelToken?: CancelToken | AbortSignal
  ) => {
    return await this.request(
      "POST",
      path,
      undefined,
      auth,
      undefined,
      undefined,
      cancelToken
    );
  };

  jwtPOST = async (
    path: string,
    jwtToken: string,
    data?: object,
    cancelToken?: CancelToken | AbortSignal
  ) => {
    const headers: any = {};
    headers.Authorization = jwtToken;
    return await this.request(
      "POST",
      path,
      headers,
      undefined,
      undefined,
      data,
      cancelToken
    );
  };
  updateCookies = (ctx: any) => {
    if (!nookies) {
      return;
    }
    this._ctx = ctx;
    const cookies = nookies.get(ctx);
    const token = cookies["access_token"];
    const account_id = Number(cookies["account_id"]);
    // console.log("updateCookies", token, account_id)
    // this.setToken(token);
    // this.setAccountId(account_id);
    console.log(`account_id`, this._account_id, account_id);
    this._token = token;
    this._account_id = account_id;
  };

  setToken = (token?: string) => {
    if (this._token === token) return;
    this._token = token;
    if (token) {
      localStorage.setItem("access_token", token);
    } else {
      localStorage.removeItem("access_token");
    }
  };

  getToken = (): string => {
    return localStorage.getItem("access_token") || "";
  };

  getAccountID = (): string => {
    return CookieManager.getCookie("account_id") || "";
  };

  request = async (
    method: Method,
    path: string,
    requestHeaders?: Record<string, string>,
    requestAuth?: AxiosBasicCredentials,
    requestParams?: Record<string, any>,
    data?: any,
    cancelToken: CancelToken | AbortSignal = ctSource.token,
    config?: AxiosRequestConfig
  ): Promise<any> => {
    let url,
      params = clone(requestParams),
      headers: any = clone(requestHeaders);
    const auth = clone(requestAuth);
    if (startsWith(path, "http")) {
      url = path;
    } else {
      const baseURL = await this.getBaseURL();
      url = baseURL + path;
    }

    if (isNil(params)) {
      params = {};
    }

    if (isNil(headers)) {
      headers = {};
    }
    headers.Accept = "application/json";
    if (!isEmpty(this.getToken()) && isNil(headers.Authorization)) {
      headers.Authorization = `Bearer ${this.getToken()}`;
    }
    if (!isEmpty(this._language) && isNil(headers["Accept-Language"])) {
      headers["Accept-Language"] = this._language!;
    }

    if (method === "GET") {
      /* empty */
    } else if (!isNil(data)) {
      if (data instanceof FormData) {
        if (headers["Content-Type"] === undefined) {
          headers["Content-Type"] = "multipart/form-data";
        }
      } else {
        // post using x-www-form-urlencoded
        headers["Content-Type"] = "application/json;charset=UTF-8";
        data = JSON.stringify(data);
      }
    }

    const axiosConfig: AxiosRequestConfig = {
      url: path,
      method,
      baseURL: this.baseURL,
      headers,
      auth,
      params,
      data,
      timeout: 6e4,
      ...config,
      ...paramsSerializer(),
    };
    if (cancelToken) {
      if (cancelToken instanceof AbortSignal) axiosConfig.signal = cancelToken;
      else axiosConfig.cancelToken = cancelToken;
    }
    try {
      const rawResponse = await axios(axiosConfig);
      // console.log(`rawResponse`, rawResponse);
      const response = rawResponse?.data;
      if (response?.error) {
        return {
          headers: rawResponse?.headers,
          error: {
            error_description:
              response?.error?.data?.message ||
              "Đã có lỗi xảy ra, vui lòng thử lại !",
            status: 400,
          },
        };
      }
      return {
        headers: rawResponse?.headers,
        response,
      };
    } catch (error: any) {
      console.log(`rawResponse Error`, error);
      this.handleError(error);
      if (axios.isCancel(error)) {
        return {
          isCanceled: true,
        };
      }
      return {
        error: {
          ...error,
          error_description:
            error?.response?.data?.message ||
            "Đã có lỗi xảy ra, vui lòng thử lại !",
          status: 400,
        },
      };
    }
  };

  parseErrorMessage = ({ error, defaultMessage }: BaseError) => {
    if (error?.response?.data?.message) {
      return error.response.data.message;
    }
    return defaultMessage;
  };

  parseErrorStatus = ({ error, defaultStatusCode }: BaseError) => {
    if (error?.response?.data?.statusCode) {
      return error.response.data.statusCode;
    }
    return defaultStatusCode;
  };

  handleError = (error: any) => {
    if (!axios.isCancel(error)) {
      if (!error?.response?.data) {
        this.forceSignOut();
      }
      console.log(`Axios error`, error);
    } else {
      console.log(`Cancel request by axios`);
    }
  };

  forceSignOut = () => {
    if (typeof window !== "undefined") {
      //   message.error("Phiên đăng nhập hết hạn");
      //   document.cookie.split(";").forEach((cookie) => {
      //     const eqPos = cookie.indexOf("=");
      //     const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      //   });
      //   localStorage.clear();
      //   window.location.href = "/auth/login";
    }
  };
}

export default Api;
